import { gql } from '@apollo/client/core'

export const BuildPresetLibraryDocument = gql`
  query BuildPresetLibrary($guildId: Int!) {
    buildPresetLibrary(guildId: $guildId) {
      playerPresets {
        discordUserId
        presets {
          id
          name
          orderIndex
          stages { stageKind weaponSlugs }
        }
      }
      guildPresets {
        id
        name
        orderIndex
        stages { stageKind weaponSlugs }
      }
    }
  }
`

export const MyBuildPresetsDocument = gql`
  query MyBuildPresets($discordUserId: Int!) {
    myBuildPresets(discordUserId: $discordUserId) {
      id
      name
      orderIndex
      stages { stageKind weaponSlugs }
    }
  }
`

export const MyBuildPresetCreateDocument = gql`
  mutation MyBuildPresetCreate($discordUserId: Int!, $name: String!, $stages: [String!]!) {
    myBuildPresetCreate(discordUserId: $discordUserId, name: $name, stages: $stages) {
      id
      name
      orderIndex
      stages { stageKind weaponSlugs }
    }
  }
`

export const MyBuildPresetUpdateDocument = gql`
  mutation MyBuildPresetUpdate($discordUserId: Int!, $presetId: Int!, $name: String!, $stages: [String!]!) {
    myBuildPresetUpdate(
      discordUserId: $discordUserId
      presetId: $presetId
      name: $name
      stages: $stages
    ) {
      id
      name
      orderIndex
      stages { stageKind weaponSlugs }
    }
  }
`

export const MyBuildPresetRemoveDocument = gql`
  mutation MyBuildPresetRemove($discordUserId: Int!, $presetId: Int!) {
    myBuildPresetRemove(discordUserId: $discordUserId, presetId: $presetId) {
      id
      name
      orderIndex
      stages { stageKind weaponSlugs }
    }
  }
`

export const GuildBuildPresetCreateDocument = gql`
  mutation GuildBuildPresetCreate($guildId: Int!, $name: String!, $stages: [String!]!) {
    guildBuildPresetCreate(guildId: $guildId, name: $name, stages: $stages)
  }
`

export const GuildBuildPresetUpdateDocument = gql`
  mutation GuildBuildPresetUpdate($guildId: Int!, $presetId: Int!, $name: String!, $stages: [String!]!) {
    guildBuildPresetUpdate(guildId: $guildId, presetId: $presetId, name: $name, stages: $stages)
  }
`

export const GuildBuildPresetRemoveDocument = gql`
  mutation GuildBuildPresetRemove($guildId: Int!, $presetId: Int!) {
    guildBuildPresetRemove(guildId: $guildId, presetId: $presetId)
  }
`

export const RaidPlayerApplyBuildPresetDocument = gql`
  mutation RaidPlayerApplyBuildPreset(
    $guildId: Int!
    $raidId: Int!
    $raidPlayerId: Int!
    $presetId: Int!
    $source: String!
  ) {
    raidPlayerApplyBuildPreset(
      guildId: $guildId
      raidId: $raidId
      raidPlayerId: $raidPlayerId
      presetId: $presetId
      source: $source
    )
  }
`
